import { render, staticRenderFns } from "./StudyInstituteEditDialog.vue?vue&type=template&id=a340216c"
import script from "./StudyInstituteEditDialog.vue?vue&type=script&lang=ts"
export * from "./StudyInstituteEditDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports